<template>
	<div v-if="mediaDetailsList.length > 1" @click="close_selection += 1">
		<v-data-table
			:class="['media-plan-table', mediaDetailsList.some(d => { return d.id === 0}) ? 'total':'']"
			:headers="taskHeaders"
			:items="mediaDetailsList"
			:items-per-page="-1"
			item-key="key"
			hide-default-header
			hide-default-footer
		>
			<template v-slot:top>
				<v-row class="ma-0 px-2 header-top header-top-height" justify="space-between" align="center">
					<v-row class="ma-0" align="center">
						<div class="font-bold-style selector-item-style mr-2" style="line-height: 20px">{{ group_name }}</div>
						<v-text-field
							v-if="false && groupBy === group_phase && edit_id !== '' && media.canEditPlan"
							class="field-in-cell field-in-top font-bold-style selector-item-style"
							style="max-width: 110px"
							:value="group_name"
							:autofocus="edit_id !== ''"
							:color="color"
							outlined
							dense
							hide-details
							height="28"
						></v-text-field>
						<v-btn v-if="false && groupBy === group_phase" icon small :disabled="!media.canEditPlan" @click="onEditNameDialog()">
							<v-icon small>mdi-pencil</v-icon>
						</v-btn>
					</v-row>
				</v-row>
			</template>
			<template v-slot:header="{ props: { headers } }">
				<thead>
					<tr>
						<th
							v-for="header in headers"
							:key="header.value"
							:style="[
								{ width: `${header.width}px`, minWidth: `${header.width}px`, maxWidth: `${header.width}px` },
								header.value === rightBorderKey || header.value === rightBorderMidKey
									? { borderRight: 'thin solid rgba(0, 0, 0, 0.12)' }
									: (header.value === 'party' ? { borderLeft: 'thin solid rgba(0, 0, 0, 0.12)' } : {})
							]"
						>
							<v-row class="ma-0" style="width: 100%" v-for="(header_item, index) in header.text" :key="`${index}_${header.value}`">
								<span class="font-bold-style font-header-style">{{ header_item }}&nbsp;</span>
							</v-row>
						</th>
					</tr>
				</thead>
			</template>
			<template v-slot:body="{ items, headers }">
				<tbody>
					<template v-if="items.length === 0">
						<tr>
							<td :colspan="headers.length">
								<v-row class="font-normal-style font-header-style ma-0 px-3" justify="center" style="line-height: 24px">
									<div>&nbsp;&nbsp;</div>
								</v-row>
							</td>
						</tr>
					</template>
					<template v-else>
						<tr v-for="(item_obj, index) in items" :key="index">
							<template v-if="item_obj.record_type === plan_type">
								<td v-for="(item, key) in filterPlanItem(item_obj)" :key="key" :style="key === rightBorderKey || key === rightBorderMidKey ? 'border-right: thin solid rgba(0, 0, 0, 0.12)':(key === 'party' ? 'border-left: thin solid rgba(0, 0, 0, 0.12)':'')" @click="onOutSideClick()">
									<div v-if="key === 'kind'" style="width: 200px">
										<v-row class="font-normal-style font-header-style mx-0 my-1" v-for="(kind, index) in item" :key="`${index}_kind`" style="line-height: 24px">
											<div v-if="typeof(kind) === 'string'" class="over-text pl-3 pr-2">{{ (kind.split('_'))[0] }}&nbsp;</div>
											<template v-if="kind !== null && typeof(kind) === 'object'">
												<template v-if="ableEdit && item_obj.is_edit">
													<KindTreeSelection
														ref="kind"
														:elementKey="item_obj.key"
														class="select-in-cell"
														:color="color"
														:bgColor="'#FAFAFA'"
														:kindParams="kindParams"
														:kindSelected="item_obj.kind[1]"
														:closeSelection="close_selection"
														:isWidthAuto="true"
														:outlined="false"
														:solo="true"
														:flat="true"
														@kind-selected="onKindChange($event, item_obj.key)"
													/>
												</template>
												<template v-else>
													<div class="pl-3 pr-2">{{ kind ? kind.display_name : ''}}&nbsp;</div>
												</template>
											</template>
										</v-row>
									</div>
									<div v-if="key === 'outlet'" style="width: 200px">
										<v-row class="font-normal-style font-header-style ma-0 px-2" justify="start" align="start" v-for="(outlet, index) in item" :key="`${index}_outlet`" style="line-height: 24px">
											<template v-if="ableEdit && item_obj.is_edit">
												<v-select
													v-if="edit_id === `outlet_${item_obj.key}`"
													class="select-in-cell"
													:value="outlet"
													:color="color"
													:menu-props="{ bottom: true, offsetY: true}"
													:loading="supplier_loading"
													:items="supplier_items"
													item-value="id"
													item-text="display_name"
													item-color="media"
													background-color="#FAFAFA"
													outlined
													dense
													hide-details
													return-object
													@click.stop
													@change="onSupplierChange($event, item_obj.key)"
												>
												</v-select>
												<div v-else :class="ableEdit ? 'hover-border' : ''" @click.stop="edit_id = `outlet_${item_obj.key}`">{{ outlet ? outlet.display_name : ''}}&nbsp;</div>
											</template>
											<template v-else>
												<div class="px-2">{{ outlet ? outlet.display_name : ''}}&nbsp;</div>
											</template>
										</v-row>
									</div>
									<div v-if="key === 'owner'" style="width: 200px">
										<v-row class="font-normal-style font-header-style ma-0 pl-4 pr-2" justify="start" align="start" v-for="(owner, index) in item" :key="`${index}_owner`" style="line-height: 24px">
											<div style="text-align: start">{{ owner ? owner.owner_name : '' }}&nbsp;</div>
										</v-row>
									</div>
									<div v-if="key === 'description'" style="width: 200px">
										<v-row class="font-normal-style font-header-style ma-0 pl-4 pr-2" justify="start" align="start" v-for="(description, index) in item" :key="`${index}_description`" style="line-height: 24px">
											<v-text-field
												v-if="edit_id === `desc_${item_obj.key}`"
												class="font-normal-style font-header-style"
												:value="description"
												:color="color"
												outlined
												dense
												hide-details
												@click.stop
												@change="onDescChange($event, item_obj.key)"
											>
											</v-text-field>
											<div v-else :class="ableEdit && item_obj.is_edit ? 'hover-border':'pl-2'" style="text-align: start" @click.stop="if(ableEdit && item_obj.is_edit) edit_id = `desc_${item_obj.key}`">{{ description }}&nbsp;</div>
										</v-row>
									</div>
									<div v-if="key === 'target'" style="width: 200px">
										<v-row class="font-normal-style font-header-style ma-0 pl-4 pr-2" justify="start" align="start" v-for="(target, index) in item" :key="`${index}_target`" style="line-height: 24px">
											<v-text-field
												v-if="edit_id === `target_${item_obj.key}`"
												class="font-normal-style font-header-style"
												:value="target"
												:color="color"
												outlined
												dense
												hide-details
												@click.stop
												@change="onTargetChange($event, item_obj.key)"
											>
											</v-text-field>
											<div v-else :class="ableEdit && item_obj.is_edit ? (target.length !== 0 ? 'hover-border':'hover-borde-empty'):''" style="text-align: start" @click.stop="if(ableEdit && item_obj.is_edit) edit_id = `target_${item_obj.key}`">{{ target }}&nbsp;</div>
										</v-row>
									</div>
									<div v-if="key === 'notes'" style="width: 200px">
										<v-row class="font-normal-style font-header-style mx-0 my-1 pl-4 pr-2" v-for="(note, index) in item" :key="`${index}_note`" style="line-height: 24px">
											<v-text-field
												v-if="edit_id === `note_${item_obj.key}`"
												class="font-normal-style font-header-style"
												:value="note"
												:color="color"
												outlined
												dense
												hide-details
												@click.stop
												@change="onNoteChange($event, item_obj.key)"
											>
											</v-text-field>
											<div v-else :class="ableEdit && item_obj.is_edit ? (note.length !== 0 ? 'hover-border':'hover-borde-empty') : ''" style="text-align: start" @click.stop="if(ableEdit && item_obj.is_edit) edit_id = `note_${item_obj.key}`">{{ note }}&nbsp;</div>
										</v-row>
									</div>
									<div v-if="key === 'units'" style="width: 80px">
										<v-row class="font-normal-style font-header-style mx-0 my-1 pl-4 pr-2" style="line-height: 24px">
											<v-btn v-if="item.units !== null && Number.isInteger(item)" depressed max-width="36" min-width="36" color="rgba(96, 90, 246, 0.1)" @click.stop="onShowBooking(item_obj.id)">
												<span class="pl-2 pr-1">{{ item }}&nbsp;</span>
											</v-btn>
										</v-row>
									</div>
									<div v-if="key === 'date'" style="width: 200px">
										<v-row class="font-normal-style font-header-style mx-0 my-1 pl-4 pr-0" v-for="(date, index) in item" :key="`${index}_date`" style="line-height: 24px">
											<span v-if="typeof(date) === 'string'" style="white-space: nowrap">{{ date }}&nbsp;</span>
											<template v-else>
												<v-row class="ma-0" justify="space-between" align="center">
													<div>
														<v-tooltip top color="#192A3E" v-for="dot in date" :key="dot.name" >
															<template v-slot:activator="{ on, attrs }">
																<span v-bind="attrs" v-on="on">
																	<v-icon v-if="dot.value !== 0" small :color="dot.color">
																		mdi-circle
																	</v-icon>
																	<v-icon v-if="dot.value === 0" small :color="dot.color">
																		mdi-currency-usd-off
																	</v-icon>
																</span>
															</template>
															<span>{{ dot.name }}</span>
														</v-tooltip>
														<span v-if="item_obj.is_foc" class="foc-style mx-1">FOC</span>
													</div>
													<v-tooltip top max-width="300" color="#192A3E" v-if="!item_obj.has_po && item_obj.bookings.every(d => { return d.rev_id === null && d.status === planned_value })">
														<template v-slot:activator="{ on, attrs }">
															<v-btn class="disable-btn" v-bind="attrs" v-on="on" :disabled="!ableDelete" icon small @click="onDeleteMediaPlan(item_obj)">
																<v-icon size="20">mdi-delete-outline</v-icon>
															</v-btn>
														</template>
														<span v-if="ableDelete">Delete</span>
														<span v-else>Insufficient privileges to use this function. Please contact your system administrator if this is incorrect.</span>
													</v-tooltip>
												</v-row>
											</template>
										</v-row>
									</div>
									<div v-if="key === 'rate'" style="width: 160px">
										<v-row class="font-normal-style font-header-style mx-0 my-1 px-4" justify="space-between" v-for="(rate, index) in item" :key="`${index}_rate`" style="line-height: 24px">
											<span v-if="rate.length !== 0" class="selector-item-style mr-2">{{ view === schedule_currency ? item_obj.cost_currency.code : item_obj.currency.code }}&nbsp;</span>
											<span>{{ rate }}&nbsp;</span>
										</v-row>
									</div>
									<div v-if="key === 'commission'" style="width: 160px">
										<v-row class="font-normal-style font-header-style  mx-0 my-1 px-4" justify="space-between" v-for="(commission, index) in item" :key="`${index}_commission`" style="line-height: 24px">
											<span v-if="commission.length !== 0" class="selector-item-style mr-2">{{ view === schedule_currency ? item_obj.cost_currency.code : item_obj.currency.code }}&nbsp;</span>
											<span>{{ commission }}&nbsp;</span>
										</v-row>
									</div>
									<div v-if="key === 'net'" style="width: 160px">
										<v-row class="font-normal-style font-header-style mx-0 my-1 px-4" justify="space-between" v-for="(net, index) in item" :key="`${index}_net`" style="line-height: 24px">
											<span v-if="net.length !== 0" class="selector-item-style mr-2">{{ view === schedule_currency ? item_obj.value_currency.code : item_obj.currency.code }}&nbsp;</span>
											<span>{{ net }}&nbsp;</span>
										</v-row>
									</div>
									<div v-if="key === 'bill'" style="width: 160px">
										<v-row class="font-normal-style font-header-style mx-0 my-1 px-4" justify="space-between" v-for="(bill, index) in item" :key="`${index}_bill`" style="line-height: 24px">
											<span v-if="bill.length !== 0" class="selector-item-style mr-2">{{ view === schedule_currency ? item_obj.value_currency.code : item_obj.currency.code }}&nbsp;</span>
											<span>{{ bill }}&nbsp;</span>
										</v-row>
									</div>
									<div v-if="key === 'margin'" style="width: 160px">
										<v-row class="font-normal-style font-header-style  mx-0 my-1 px-4" justify="space-between" v-for="(margin, index) in item" :key="`${index}_margin`" style="line-height: 24px">
											<v-icon v-if="index === 0" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-currency-usd</v-icon>
											<v-icon v-if="index === 1" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-percent-outline</v-icon>
											<span>{{ margin }}&nbsp;</span>
										</v-row>
									</div>
									<div v-if="key === 'revenue'" style="width: 160px">
										<v-row class="font-normal-style font-header-style  mx-0 my-1 px-4" justify="space-between" v-for="(revenue, index) in item" :key="`${index}_revenue`" style="line-height: 24px">
											<v-icon v-if="index === 0" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-currency-usd</v-icon>
											<v-icon v-if="index === 1" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-percent-outline</v-icon>
											<span>{{ revenue }}&nbsp;</span>
										</v-row>
									</div>
									<div v-if="key === 'party'" style="width: 180px">
										<v-row class="font-normal-style font-header-style  mx-0 my-1 px-4" justify="space-between" v-for="(party, index) in item" :key="`${index}_party`" style="line-height: 24px">
											<v-icon v-if="party.length !== 0" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-percent-outline</v-icon>
											<span>{{ party }}&nbsp;</span>
										</v-row>
									</div>
								</td>
							</template>
							<template v-else-if="item_obj.record_type === prod_type">
								<td v-if="headers.findIndex(header => { return header.value === 'kind' }) !== -1" style="width: 200px" @click="onOutSideClick()">
									<v-row class="font-normal-style font-header-style mx-0 my-1" v-for="(kind, index) in item_obj.kind" :key="`${index}_kind`" style="line-height: 24px;">
										<span v-if="typeof(kind) === 'string'" class="over-text pl-3 pr-2">{{ (kind.split('_'))[0] }}&nbsp;</span>
										<template v-if="kind !== null && typeof(kind) === 'object'">
											<template v-if="ableEdit">
												<KindTreeSelection
													ref="kind"
													:elementKey="item_obj.key"
													class="select-in-cell"
													:color="color"
													:bgColor="'#FAFAFA'"
													:kindParams="kindParams"
													:kindSelected="kind"
													:closeSelection="close_selection"
													:isWidthAuto="true"
													:outlined="false"
													:solo="true"
													:flat="true"
													@kind-selected="onKindChange($event, item_obj.key)"
												/>
											</template>
											<template v-else>
												<div class="pl-3 pr-2">{{ kind ? kind.display_name : ''}}&nbsp;</div>
											</template>
										</template>
									</v-row>
								</td>
								<td v-if="prodColspan !== 0" :colspan="prodColspan" @click="onOutSideClick()">
									<template v-if="headers.findIndex(head => { return head.value === 'description'}) > 0">
										<v-row class="font-normal-style font-header-style ma-0 pl-3 pr-2" justify="start" align="start" v-for="(description, index) in item_obj.description" :key="`${index}_description`" style="line-height: 24px">
											<v-text-field
												v-if="edit_id === `desc_${item_obj.key}`"
												class="font-normal-style font-header-style"
												:value="description"
												:color="color"
												outlined
												dense
												hide-details
												@click.stop
												@change="onDescChange($event, item_obj.key)"
											>
											</v-text-field>
											<div v-else :class="ableEdit ? 'hover-border' : ''" style="text-align: start" @click.stop="if(ableEdit) edit_id = `desc_${item_obj.key}`">{{ description }}&nbsp;</div>
										</v-row>
									</template>
								</td>
								<td v-for="(item, key) in filterItem(item_obj)" :key="key" :style="key === rightBorderKey || key === rightBorderMidKey ? 'border-right: thin solid rgba(0, 0, 0, 0.12)':(key === 'party' ? 'border-left: thin solid rgba(0, 0, 0, 0.12)':'')" @click="onOutSideClick()">
									<div v-if="key === 'units'" style="width: 80px">
										<v-row class="font-normal-style font-header-style mx-0 my-1 pl-4 pr-2" style="line-height: 24px">
											<v-btn v-if="item === null" icon :disabled="!ableEdit" @click.stop="onUnitEdit(item_obj)">
												<v-icon small>mdi-pencil</v-icon>
											</v-btn>
										</v-row>
									</div>
									<div v-else-if="key === 'date'" style="width: 200px">
										<v-row class="font-normal-style font-header-style mx-0 my-1 pl-4 pr-0" v-for="(date, index) in item" :key="`${index}_date`" style="line-height: 24px">
											<span v-if="typeof(date) === 'string'" style="white-space: nowrap">{{ date }}&nbsp;</span>
											<v-row v-else class="ma-0" justify="space-between">
												<div>
													<v-tooltip top color="#192A3E" v-for="dot in date" :key="dot.name" >
														<template v-slot:activator="{ on, attrs }">
															<span v-bind="attrs" v-on="on">
																<v-icon v-if="dot.value !== 0" small :color="dot.color">
																	mdi-circle
																</v-icon>
																<v-icon v-if="dot.value === 0" small :color="dot.color">
																	mdi-currency-usd-off
																</v-icon>
															</span>
														</template>
														<span>{{ dot.name }}</span>
													</v-tooltip>
												</div>
												<v-tooltip top max-width="300" color="#192A3E" v-if="(date.filter(d => { return d.value !== 0})).every(d => { return d.value === planned_value })">
													<template v-slot:activator="{ on, attrs }">
														<v-btn class="disable-btn" v-bind="attrs" v-on="on" :disabled="!ableDelete" icon small @click="onDeleteMediaPlan(item_obj)">
															<v-icon size="20">mdi-delete-outline</v-icon>
														</v-btn>
													</template>
													<span v-if="ableDelete">Delete</span>
													<span v-else>Insufficient privileges to use this function. Please contact your system administrator if this is incorrect.</span>
												</v-tooltip>
											</v-row>
										</v-row>
									</div>
									<div v-else-if="key === 'bill'" style="width: 160px">
										<v-row class="font-normal-style font-header-style mx-0 my-1 px-4" justify="space-between" v-for="(bill, index) in item" :key="`${index}_bill`" style="line-height: 24px;flex-wrap: nowrap;">
											<span v-if="bill.length !== 0" class="selector-item-style mr-2">{{ view === schedule_currency ? item_obj.value_currency.code : item_obj.currency.code }}&nbsp;</span>
											<span>{{ bill }}&nbsp;</span>
										</v-row>
									</div>
									<div v-else style="width: 160px">
										<v-row class="font-normal-style font-header-style  mx-0 my-1 pl-4" justify="space-between" style="line-height: 24px;">
											<span>&nbsp;&nbsp;</span>
										</v-row>
									</div>
								</td>
							</template>
							<template v-else-if="item_obj.record_type === info_type || item_obj.record_type === tcp_type">
								<td :colspan="infoColspan">
									<v-row class="info-description-row font-normal-style font-header-style ma-0 pl-3 pr-2" justify="start" align="start" style="line-height: 24px">
										<div class="info-description py-1 px-2">{{ item_obj.description }}&nbsp;</div>
									</v-row>
								</td>
								<td v-for="(item, key) in filterItem(item_obj)" :key="key" :style="key === rightBorderKey || key === rightBorderMidKey ? 'border-right: thin solid rgba(0, 0, 0, 0.12)':(key === 'party' ? 'border-left: thin solid rgba(0, 0, 0, 0.12)':'')">
									<div v-if="key === 'units'" style="width: 80px">
										<v-row class="font-normal-style font-header-style mx-0 my-1 pl-4 pr-2" style="line-height: 24px">
											<v-btn v-if="item === null" icon :disabled="!ableEdit" @click="onUnitEdit(item_obj)">
												<v-icon small>mdi-pencil</v-icon>
											</v-btn>
											<v-btn v-if="item !== null && Number.isInteger(item)" depressed max-width="36" min-width="36" color="rgba(96, 90, 246, 0.1)" @click="onShowBooking(item_obj.id)">
												<span class="pl-2 pr-1">{{ item }}&nbsp;</span>
											</v-btn>
										</v-row>
									</div>
									<div v-else-if="key === 'date'" style="width: 200px">
										<v-row class="ma-0 pl-4 pr-0" justify="end">
											<v-tooltip top max-width="300" color="#192A3E" v-if="item_obj.record_type === info_type || (item_obj.record_type === tcp_type && !item_obj.has_po)" >
												<template v-slot:activator="{ on, attrs }">
													<v-btn class="disable-btn" v-bind="attrs" v-on="on" :disabled="!ableDelete" icon small @click="onDeleteMediaPlan(item_obj)">
														<v-icon size="20">mdi-delete-outline</v-icon>
													</v-btn>
												</template>
												<span v-if="ableDelete">Delete</span>
												<span v-else>Insufficient privileges to use this function. Please contact your system administrator if this is incorrect.</span>
											</v-tooltip>
										</v-row>
									</div>
									<div v-else-if="key === 'party'" style="width: 180px">
										<v-row class="font-normal-style font-header-style  mx-0 my-1 px-4" justify="space-between" v-for="(party, index) in item" :key="`${index}_party`" style="line-height: 24px;">
											<v-icon v-if="party.length !== 0" small color="rgba(25, 42, 62, 0.5)" class="mt-0">mdi-percent-outline</v-icon>
											<span>{{ party }}&nbsp;</span>
										</v-row>
									</div>
									<div v-else style="width: 160px">
										<v-row class="font-normal-style font-header-style  mx-0 my-1 px-4" justify="space-between" style="line-height: 24px;">
											<span>&nbsp;&nbsp;</span>
										</v-row>
									</div>
								</td>
							</template>
							<template v-else>
								<td :colspan="totalColspan" style="border-right: thin solid rgba(0, 0, 0, 0.12)">
									<v-row class="font-bold-style font-header-style ma-0 px-3" justify="end" style="line-height: 24px">
										<div style="text-align: end">Totals&nbsp;for&nbsp;{{ group_name }}:&nbsp;</div>
									</v-row>
								</td>
								<td v-for="(item, key) in filterTotalItem(item_obj)" :key="key" :style="key === rightBorderMidKey ? 'border-right: thin solid rgba(0, 0, 0, 0.12)':(key === 'party' ? 'border-left: thin solid rgba(0, 0, 0, 0.12)':'')">
									<div :style="`width: ${(headers.filter(h => { return h.value === key}))[0].width}px`">
										<v-row class="font-bold-style font-header-style mx-0 my-1 px-4" justify="space-between">
											<span v-if="item.length !== 0" class="selector-item-style">{{ item.split('_')[0] }}&nbsp;</span>
											<span>{{ item.split('_')[1] }}&nbsp;</span>
										</v-row>
									</div>
								</td>
							</template>
						</tr>
					</template>
				</tbody>
			</template>
		</v-data-table>
		<DeleteConfirmDialog
			v-if="delete_confirm_visible"
			:visible="delete_confirm_visible" 
			:color="'error'"
			:title="`Delete bookings`" 
			:content="content_msg"
			:ok="'Delete bookings'"
			:icon_name_title="'mdi-alert-circle'"
			:maxWidth="500"
			@cancel="delete_confirm_visible = false"
			@ok="onDelMediaPlan()"
		/>
		<PhaseDialog
			v-if="phase_dialog_visible"
			:visible="phase_dialog_visible" 
			:color="color" 
			@close="phase_dialog_visible = false" 
		/>
		<DialogConfirmNotice
			v-if="visible_notice" 
			:visible="visible_notice" 
			:text="notice_text"
			:color="notice_color"
			@ok="close()"
		/>
	</div>
</template>

<script>
import KindTreeSelection from "@/components/kinds/kind_tree_selection.vue";
import PhaseDialog from "@/views/desktop/media/media_planning_phase_dialog.vue";
import DeleteConfirmDialog from "@/components/dialogs/delete_comfirm_dialog.vue";
import DialogConfirmNotice from "@/components/dialogs/notice_confirm_dialog.vue";

import Decimal from 'decimal.js';
import moment from 'moment';

/**
 * https://github.com/antoniolucasnobar/html-to-rtf-browser
 * copy whole src into project(removing testing file)
 **/
import Rtf from "@/views/rtf/html_to_rtf/rtf/rtf.class.js";
const htmlToRtf = new Rtf();

const Media_Owner = 'owner';
const Media_Outlet = 'outlet';
const Group_Kind = 'kind';
const Group_Phase = 'phase';

const Date_Range_Week = 'week';
const Date_Range_Month = 'month';
const Date_Range_Next_Month = 'next_month';
const Date_Range_Last_Month = 'last_month';
const Date_Range_Range = 'range';

const Schedule_Currency = 'schedule';

const INFO_TYPE = 'INFO';
const PROD_TYPE = 'PROD';
const PLAN_TYPE = 'PLAN';
const TPC_TYPE = 'TPC';

const Planned_Color = '#8C7503';
const Unapproved_Color = '#D5A39B';
const Booked_Color = '#C35643';
const Test_Invoice_Color = '#9DB475';
const Invoiced_Color = '#547F0A';
const Credit_Note_Color = '#2C4108';
const Reversed_Color = '#A79C9C';
const Reversal_Color = '#726A6A';
const DoNotBill_Color = 'rgba(25, 42, 62, 0.5)';

/** 0-New, 1-Planned,2-Booked,3-On Test Invoice,4-Invoiced,5-On Test Credit Note */
const Booking_Status = [
	{
		name: 'Do not bill',
		value: 0,
		color: DoNotBill_Color,
		range: [0]
	},
	{
		name: 'Planned',
		value: 1,
		color: Planned_Color,
		range: [1]
	},
	{
		name: 'Booked',
		value: 2,
		color: Booked_Color,
		range: [2]
	},
	{
		name: 'Test Invoice',
		value: 3,
		color: Test_Invoice_Color,
		range: [3]
	},
	{
		name: 'Invoiced',
		value: 4,
		color: Invoiced_Color,
		range: [4]
	},
	{
		name: 'Test Credit Note',
		value: 5,
		color: Credit_Note_Color,
		range: [5]
	},
	{
		name: 'Unapproved PO',
		value: 6,
		color: Unapproved_Color,
		range: [6]
	},
	{
		name: 'Reversed',
		value: 100,
		color: Reversed_Color,
		range: [100]
	},
	{
		name: 'Reversal',
		value: 101,
		color: Reversal_Color,
		range: [101]
	}
];
const Reversed_Value = 100;
const Reversal_Value = 101;
const Planned_Value = 1;
const Unapproved_Po_Value = 6;
const Left_Header = ['kind', 'outlet', 'owner', 'description', 'target', 'notes', 'units', 'date'];
const Mid_Header = ['rate', 'commission', 'net'];

/** Amend media booking */
const MEDED = 'MedEd';
/** Delete media booking */
const MEDDEL = 'MedDel';

const Plan_Lock_Text = 'Media plan is already locked by you from other place';
const Pord_Lock_Text = 'Poduction is already locked by you from other place';

export default {
	name: 'MediaPlanTable',
	props: {
		color: {
			type: String,
			default: '',
		},
		privileges: {
			type: Array,
			default: () => []
		},
		jobId: {
			type: Number,
			default: 0
		},
		groupBy: {
			type: String,
			default: '',
		},
		statusSelect: {
			type: Array,
			default: () => []
		},
		dateRange: {
			type: String,
			default: ''
		},
		dates: {
			type: Array,
			default: () => []
		},
		dayOfWeek: {
			type: Number,
			default: 0
		},
		taskHeaders: {
			type: Array,
			default: () => []
		},
		isShow: {
			type: Boolean,
			default: true
		},
		view: {
			type: String,
			default: ''
		},
		snapId: {
			type: Number,
			default: 0
		},
		media: {
			type: Object,
			default: null
		},
		kindParams: {
			type: Object,
			default: null
		},
		seachKey: {
			type: String,
			default: ''
		}
	},
	data() {
		this.media_owner = Media_Owner;
		this.media_outlet = Media_Outlet;
		this.group_kind = Group_Kind;
		this.group_phase = Group_Phase;
		this.schedule_currency = Schedule_Currency;

		this.info_type = INFO_TYPE;
		this.prod_type = PROD_TYPE;
		this.plan_type = PLAN_TYPE;
		this.tcp_type = TPC_TYPE;

		this.planned_value = Planned_Value;

		return {
			error_msg: '',
			close_selection: 0,
			group_name: this.media.desc,
			edit_id: '',

			supplier_items: [],

			content_msg: '',
			delete_media_id: 0,
			delete_confirm_visible: false,
			phase_dialog_visible: false,

			visible_notice: false,
			notice_text: [],
			notice_color: '#FF5252',
		}
	},
	components: {
		KindTreeSelection,
		PhaseDialog,
		DeleteConfirmDialog,
		DialogConfirmNotice
	},
	created() {
		this.getSupplierList();
	},
	computed: {
		mediaDetailsList() {
			let media_details_list = [];

			if (this.media && this.media.details && this.media.details.length !== 0) {
				let table_list = [];

				this.media.details.forEach(media_detail => {
					const media = JSON.parse(JSON.stringify(media_detail));
					/** planned_bookings and amout_value, for delete message */
					let planned_bookings = [];
					let amout_value = '';
					
					/** filter by status */
					let status_value_arr = [];
					this.statusSelect.forEach(status => {
						status_value_arr = [...status_value_arr, ...status.range]
					});

					if (status_value_arr.includes(Reversed_Value)) {
						status_value_arr.push(Reversal_Value)
					}

					if (media.record_type === PLAN_TYPE) {
						planned_bookings = media.bookings.filter(b => { return b.rev_id === null && b.status === Planned_Value });
						
						const formatted_amout_value  = new Intl.NumberFormat('en-US', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2
						}).format(media.totals.value_fc);
						amout_value = `${media.value_currency.symbol} ${formatted_amout_value}`

						if (this.statusSelect.length === 0) {
							media['bookings'] = [];
						} else {
							media.bookings.forEach(booking => {
								if (booking.rev_id !== null && booking.rev_id > Planned_Value) {
									booking['status_id'] = Reversal_Value;
								} else if(booking.rev_id !== null && booking.rev_id === Planned_Value) {
									booking['status_id'] = Reversed_Value;
								} else if(booking.rev_id === null && booking.status === Planned_Value && booking.has_po === true) {
									booking['status_id'] = Unapproved_Po_Value;
								} else {
									booking['status_id'] = booking.status;
								}
							});

							const bookings = media.bookings.filter(booking => { return status_value_arr.includes(booking.status_id) });
							media['bookings'] = bookings;
						}
					}
					if (media.record_type === TPC_TYPE) {
						if (media.details && media.details.length !== 0) {
							let bookings = [];

							media.details.forEach(detail => {
								const booking_filter = (Array.isArray(detail.bookings) ? detail.bookings : [])
									.filter(booking => { return status_value_arr.includes(booking.booking_status) });
								bookings = [...bookings, ...booking_filter];
							});

							media['bookings'] = bookings;
						} else {
							return;
						}
					}
					if (media.record_type === PROD_TYPE) {
						if (status_value_arr.includes(media.status)) {
							media['statusFilter'] = true;
						} else {
							media['statusFilter'] = false;
						}
					}
					

					/** filter by date range */
					let date_range = [];
					if (this.dateRange === Date_Range_Week) {
						date_range = this.curWeek;
					}
					if (this.dateRange === Date_Range_Month) {
						date_range = this.curMonth;
					}
					if (this.dateRange === Date_Range_Next_Month) {
						date_range = this.nextMonth;
					}
					if (this.dateRange === Date_Range_Last_Month) {
						date_range = this.lastMonth;
					}
					if (this.dateRange === Date_Range_Range) {
						date_range = this.dates;
					}
						
					if (media.record_type === PLAN_TYPE) {
						/**
						 * Filter by booking_start only, including both date-range boundaries.
						 * Example: a 29 Jul–3 Aug booking appears in July, but not in August.
						 */
						const bookings = media.bookings.filter(booking => {
							const start_date = moment(booking.booking_start, 'YYYYMMDD').format('YYYY-MM-DD');
							const is_fall_range = this.isFallRange(start_date, date_range);
							if (is_fall_range) {
								return booking;
							}
						});

						media['bookings'] = bookings;
					}
					if (media.record_type === TPC_TYPE) {
						/**
						 * Filter by booking_start only, including both date-range boundaries.
						 * Example: a 29 Jul–3 Aug booking appears in July, but not in August.
						 */
						const bookings = media.bookings.filter(booking => {
							const start_date = moment(booking.booking_start, ['YYYYMMDD', 'YYYY-MM-DD']).format('YYYY-MM-DD');
							const is_fall_range = this.isFallRange(start_date, date_range);
							if (is_fall_range) {
								return booking;
							}
						});

						media['bookings'] = bookings;
					}
					if (media.record_type === PROD_TYPE) {
						if (date_range.length === 0) {
							media['dateFilter'] = true;
						} else {
							const start_date = moment(media.prod_start, 'YYYYMMDD').format('YYYY-MM-DD');
							if (moment(start_date).isBetween(date_range[0], date_range[1], undefined, '[]')) {
								media['dateFilter'] = true;
							} else {
								media['dateFilter'] = false;
							}
						}
					}


					if (media.kind) {
						media.kind['display_name'] = media.kind.name;
					}

					const media_obj = {};
					media_obj['id'] = media.id;
					media_obj['key'] = `${media.record_type}_${media.id}`;
					media_obj['record_type'] = media.record_type;					
					media_obj['currency'] = media.currency ? media.currency : '';
					media_obj['cost_currency'] = media.cost_currency ? media.cost_currency : '';
					media_obj['value_currency'] = media.value_currency ? media.value_currency : '';
					
					media_obj['units'] = media.totals ? media.totals.units : null;
					media_obj['phase'] = media.phase;
					media_obj['outlet'] = media.supplier ? [media.supplier] : null;
					media_obj['owner'] = media.supplier ? [media.supplier] : null;

					media_obj['booking_plan'] = planned_bookings.length;
					media_obj['total_bill_client'] = amout_value;


					if (media.record_type === INFO_TYPE) {
						media_obj['description'] = media.info_text;
						media_obj['date'] = null;
						media_obj['rate'] = null;
						media_obj['commission'] = null;
						media_obj['net'] = null;
						media_obj['bill'] = null;
						media_obj['margin'] = null;
						media_obj['revenue'] = null;
						media_obj['party'] = null;
					} else if (media.record_type === TPC_TYPE) {
						/** 0 - Gross, 1 - Net, 2 - Bill to client */
						const apply_to_str = ['Gross', 'Net', 'Bill to client']
						media_obj['description'] = `Third party commission for supplier: ${media.tpc_supplier.adbShort}, comm%: ${media.tpc_commperc}, apply over: ${apply_to_str[media.tpc_applyto]}`;
						media_obj['date'] = null;
						media_obj['rate'] = null;
						media_obj['commission'] = null;
						media_obj['net'] = null;
						media_obj['bill'] = null;
						media_obj['margin'] = null;
						media_obj['revenue'] = null;
						media_obj['has_po'] = media.has_po;
												
						/** 3rd party commission  */
						const tpc_commperc = new Decimal(media.tpc_commperc);
						const fixed_tpc_commperc = tpc_commperc.toFixed(2);
						const formatted_tpc_commperc = new Intl.NumberFormat('en-US', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2
						}).format(fixed_tpc_commperc);

						media_obj['party'] = [formatted_tpc_commperc, ''];

						if (media.bookings && media.bookings.length === 0) {
							media_obj['total_party'] = { currency: this.view === Schedule_Currency ?  media.tpc_currency : media.currency, value: 0 };
						} else {
							const gross_value_arr = media.bookings.map(booking => { return Number((booking.booking_gross_fc * (this.view === Schedule_Currency ? booking.tpc_booking_exrate_fc : booking.tpc_booking_exrate_div)).toFixed(2)) });
							const gross_total_amount = gross_value_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
							const gross_amount = new Decimal(gross_total_amount * tpc_commperc / 100);
							const fixed_gross_amount = gross_amount.toFixed(2);
						
							media_obj['total_party'] = { currency: this.view === Schedule_Currency ?  media.tpc_currency : media.currency, value: Number(fixed_gross_amount) };
						}

					} else if (media.record_type === PROD_TYPE) {
						media_obj['kind'] = [media.phase.desc, media.kind ? media.kind : null];
						media_obj['description'] = [media.description];
						media_obj['value_currency'] = media.currency;
						media_obj['do_not_bill'] = media.do_not_bill;

						const date_str = `${moment(media.prod_start).format('DD MMM YYYY')} - ${moment(media.prod_end).format('DD MMM YYYY')}`
						
						const status_arr = [];
						if (media.do_not_bill) {
							const do_not_bill_arr = Booking_Status.filter(status_item => { return status_item.value === 0 });
							status_arr.push(do_not_bill_arr[0]);
						}
						media_obj['date'] = [date_str, status_arr];

						media_obj['rate'] = null;
						media_obj['commission'] = null;						
						media_obj['net'] = null;

						/** Bill to client */
						const value = media.statusFilter === true && media.dateFilter === true ? media.amount_div : 0;
						const value_fc = new Decimal(value);
						const fixed_value_fc = value_fc.toFixed(2);
						const formatted_value_fc = new Intl.NumberFormat('en-US', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2
						}).format(fixed_value_fc);
						media_obj['bill'] = [formatted_value_fc, ''];
						
						media_obj['margin'] = null;
						media_obj['revenue'] = null;
						media_obj['party'] = null;

						media_obj['total_bill'] = { currency: media.currency, value: value };
						media_obj['total_net'] = { currency: media.currency, value: 0 };

					} else {
						media_obj['kind'] = [media.phase.desc, media.kind ? media.kind : null];
						media_obj['description'] = [media.description];
						media_obj['target'] = [media.target];
						media_obj['notes'] = [media.notes];
						media_obj['bookings'] = media_detail.bookings;

						/** merge date and status */
						let date_str = '';
						let status_arr = [];
						if (media.bookings && media.bookings.length !== 0) {
							const start_date_arr = media.bookings.map(b => { return b.booking_start });

							start_date_arr.sort((a, b) => {
								const date_a = moment(a, 'YYYYMMDD').format('YYYY-MM-DD');
								const date_b = moment(b, 'YYYYMMDD').format('YYYY-MM-DD');
								return new Date(date_a) - new Date(date_b);
							});
							date_str = `${moment(start_date_arr[0]).format('DD MMM YYYY')} - ${moment(start_date_arr[start_date_arr.length - 1]).format('DD MMM YYYY')}`;

							const status_all = media.bookings.map(b => { return b.rev_id === null ? (b.status === Planned_Value && b.has_po === true ? Unapproved_Po_Value : b.status) : null });
							const rev_id_all = media.bookings.map(b => { return b.rev_id });

							const status_all_without_null = status_all.filter(s => { return s !== null });
							const rev_id_all_without_null = rev_id_all.filter(s => { return s !== null });

							const status_set = new Set(status_all_without_null);
							const rev_id_set = new Set(rev_id_all_without_null);

							status_set.forEach(s => {
								const booking_status = Booking_Status.filter(status_item => { return status_item.range.includes(s) });
								if (booking_status.length !== 0) {
									status_arr.push(booking_status[0]);
								}
							});

							let reversed_count = 0;
							let reversal_count = 0;

							rev_id_set.forEach(r => {
								/** rev_id - None, 1-Reversed, >1 Reversal */
								if (r === 1) {
									reversed_count += 1;
								}
								if (r > 1) {
									reversal_count += 1;
								}
							});

							if (reversed_count !== 0) {
								const booking_status = Booking_Status.filter(status_item => { return status_item.value === Reversed_Value });
								status_arr.push(booking_status[0]);
							}
							if (reversal_count !== 0) {
								const booking_status = Booking_Status.filter(status_item => { return status_item.value === Reversal_Value });
								status_arr.push(booking_status[0]);
							}

							const is_do_not_bill = media.bookings.some(b => { return b.donotbill === true });
							if (is_do_not_bill) {
								const do_not_bill_arr = Booking_Status.filter(status_item => { return status_item.value === 0 });
								status_arr.push(do_not_bill_arr[0]);
							}
						}
						media_obj['date'] = [date_str, status_arr];

						const is_has_po = media_detail.bookings.some(b => { return b.has_po === true });
						media_obj['has_po'] = is_has_po;

						const is_foc = media.bookings.some(b => { return b.is_foc === true });
						media_obj['is_foc'] = is_foc;

						const is_edit = media_detail.bookings.every(b => { return b.status <= Planned_Value && b.has_po === false && b.has_cinv === false });
						media_obj['is_edit'] = is_edit;

						/** calculation for value */
						const calculation_bookings = media.bookings.filter(booking => { return booking.status_id !== Reversal_Value && booking.status_id !== Reversed_Value });

						if (calculation_bookings.length === 0) {
							const value = 0;
							const value_str = '0.00';

							media_obj['bill'] = [value_str, ''];
							media_obj['total_bill'] = { currency: this.view === Schedule_Currency ? media.value_currency : media.currency, value: value };

							media_obj['rate'] = [value_str, value_str];
							media_obj['total_rate'] = { currency: this.view === Schedule_Currency ? media.cost_currency : media.currency, value: value };

							media_obj['commission'] = [value_str, ''];
							media_obj['total_commission'] = { currency: this.view === Schedule_Currency ? media.cost_currency : media.currency, value: value };

							media_obj['net'] = [value_str, ''];
							media_obj['total_net'] = { currency: this.view === Schedule_Currency ? media.value_currency : media.currency, value: value };

							const margin_perc = new Decimal(media.exrate_margin_perc);
							const fixed_margin_perc = margin_perc.toFixed(2);
							const formatted_margin_perc = new Intl.NumberFormat('en-US', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2
							}).format(fixed_margin_perc);
							media_obj['margin'] = [value_str, formatted_margin_perc];
							media_obj['revenue'] = [value_str, value_str];

						} else {
							/** Supplier rate and Supplier Amount */
							const rate_value_arr = calculation_bookings.map(booking => { return this.view === Schedule_Currency ? booking.rate_fc : booking.rate_div });
							const rate_total_amount = rate_value_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
							const rate_amount = new Decimal(rate_total_amount / calculation_bookings.length);
							const fixed_rate_amount = rate_amount.toFixed(2);
							const formatted_rate_amount = new Intl.NumberFormat('en-US', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2
							}).format(fixed_rate_amount);

							const amount_value_arr = calculation_bookings.map(booking => { return this.view === Schedule_Currency ? booking.amount_fc : booking.amount_div });
							const amount_total_amount = amount_value_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
							const amount_amount = new Decimal(amount_total_amount);
							const fixed_amount_amount = amount_amount.toFixed(2);
							const formatted_amount_amount = new Intl.NumberFormat('en-US', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2
							}).format(fixed_amount_amount);

							media_obj['rate'] = [formatted_rate_amount, formatted_amount_amount];
							media_obj['total_rate'] = { currency: this.view === Schedule_Currency ? media.cost_currency : media.currency, value: amount_total_amount };


							/** Commission ($), Commission (%) */
							const commission_value_arr = calculation_bookings.map(booking => { return this.view === Schedule_Currency ? booking.commamount_fc : booking.commamount_div });
							const commission_total_amount = commission_value_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
							const commission_amount = new Decimal(commission_total_amount);
							const fixed_commission_amount = commission_amount.toFixed(2);
							const formatted_commission_amount = new Intl.NumberFormat('en-US', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2
							}).format(fixed_commission_amount);

							media_obj['commission'] = [formatted_commission_amount, ''];
							media_obj['total_commission'] = { currency: this.view === Schedule_Currency ? media.cost_currency : media.currency, value: commission_total_amount };


							/** Net */
							const net_value_arr = calculation_bookings.map(booking => { return this.view === Schedule_Currency ? booking.net_fc : booking.net_div });
							const net_total_amount = net_value_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
							const net_amount = new Decimal(net_total_amount);
							const fixed_net_amount = net_amount.toFixed(2);
							const formatted_net_amount = new Intl.NumberFormat('en-US', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2
							}).format(fixed_net_amount);

							media_obj['net'] = [formatted_net_amount, ''];
							media_obj['total_net'] = { currency: this.view === Schedule_Currency ? media.value_currency : media.currency, value: net_total_amount };


							/** Margin ($), Margin (%) */
							const margin_value_arr = calculation_bookings.map(booking => { return this.view === Schedule_Currency ? booking.margin_fc : booking.margin_div });
							const margin_total_amount = margin_value_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
							const margin_amount = new Decimal(margin_total_amount);
							const fixed_margin_amount = margin_amount.toFixed(2);
							const formatted_margin_amount = new Intl.NumberFormat('en-US', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2
							}).format(fixed_margin_amount);

							const margin_perc = new Decimal(media.exrate_margin_perc);
							const fixed_margin_perc = margin_perc.toFixed(2);
							const formatted_margin_perc = new Intl.NumberFormat('en-US', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2
							}).format(fixed_margin_perc);

							media_obj['margin'] = [formatted_margin_amount, formatted_margin_perc];


							/** Revenue and Revenue */
							const revenue_value_arr = calculation_bookings.map(booking => { return this.view === Schedule_Currency ? booking.revenue_fc : booking.revenue_div });
							const revenue_total_amount = revenue_value_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
							const fixed_revenue_fc = revenue_total_amount.toFixed(2);
							const formatted_revenue_fc = new Intl.NumberFormat('en-US', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2
							}).format(fixed_revenue_fc);

							const revenueperc = new Decimal(media.totals.revenueperc);
							const fixed_revenueperc = revenueperc.toFixed(2);
							const formatted_revenueperc = new Intl.NumberFormat('en-US', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2
							}).format(fixed_revenueperc);

							media_obj['revenue'] = [formatted_revenue_fc, formatted_revenueperc];


							/** Bill to client */
							const bill_value_arr = calculation_bookings.map(booking => { return this.view === Schedule_Currency ? booking.value_fc : booking.value_div });
							const bill_total_amount = bill_value_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
							const bill_amount = new Decimal(bill_total_amount);
							const fixed_bill_amount = bill_amount.toFixed(2);
							const formatted_bill_amount = new Intl.NumberFormat('en-US', {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2
							}).format(fixed_bill_amount);
							media_obj['bill'] = [formatted_bill_amount, ''];
							media_obj['total_bill'] = { currency: this.view === Schedule_Currency ? media.value_currency : media.currency, value: bill_total_amount };
						}
					}
					const search_fields = ['description', 'outlet', 'owner', 'target', 'notes'];
					const matches_search = this.normalisedSeachKey.length === 0 || search_fields.length === 0 || search_fields.some(field => {
						return this.getPreSearchArr(media_obj[field]).some(text => { return text.toLowerCase().includes(this.normalisedSeachKey) });
					});

					if (matches_search) {
						table_list.push(media_obj);
					}
				});

				/** sort by start date */	
				/** Media_Owner, Media_Outlet and Kind, sort by phase first, then date */	
				const table_list_plan_date = table_list.filter(list => { return list['record_type'] === PLAN_TYPE && list['date'] });
				if (this.groupBy === Group_Phase) {
					table_list_plan_date.sort((a,b) => {
						const date_a = moment((a['date'][0]).split(' - ')[0], 'DD MMM YYYY').format('YYYY-MM-DD');
						const date_b = moment((b['date'][0]).split(' - ')[0], 'DD MMM YYYY').format('YYYY-MM-DD');
						return new Date(date_a) - new Date(date_b);
					});
				} else {
					table_list_plan_date.sort((a,b) => {
						if (a['kind'][0]=== b['kind'][0]) {
							const date_a = moment((a['date'][0]).split(' - ')[0], 'DD MMM YYYY').format('YYYY-MM-DD');
							const date_b = moment((b['date'][0]).split(' - ')[0], 'DD MMM YYYY').format('YYYY-MM-DD');
							return new Date(date_a) - new Date(date_b);
						}
					});
				}				

				const table_list_plan_no_date = table_list.filter(list => { return list['record_type'] === PLAN_TYPE && !list['date'] });
				const table_list_plan = [...table_list_plan_date, ...table_list_plan_no_date];

				const table_list_prod = table_list.filter(list => { return list['record_type'] === PROD_TYPE });
				if (this.groupBy === Group_Phase) {
					table_list_prod.sort((a,b) => {
						const date_a = moment((a['date'][0]).split(' - ')[0], 'DD MMM YYYY').format('YYYY-MM-DD');
						const date_b = moment((b['date'][0]).split(' - ')[0], 'DD MMM YYYY').format('YYYY-MM-DD');

						return new Date(date_a) - new Date(date_b);
					});
				} else {
					table_list_prod.sort((a,b) => {
						if (a['kind'][0]=== b['kind'][0]) {
							const date_a = moment((a['date'][0]).split(' - ')[0], 'DD MMM YYYY').format('YYYY-MM-DD');
							const date_b = moment((b['date'][0]).split(' - ')[0], 'DD MMM YYYY').format('YYYY-MM-DD');
							return new Date(date_a) - new Date(date_b);
						}
					});
				}

				const table_list_other = table_list.filter(list => { return list['record_type'] !== PLAN_TYPE && list['record_type'] !== PROD_TYPE });

				table_list = [...table_list_plan, ...table_list_prod, ...table_list_other];
				


				/** add last total line */
				const rate_list = table_list.filter(list => { return list.total_rate });
				const supp_amount_arr = rate_list.map(list => { return list.total_rate });
				const total_rate = this.totalCalculate(supp_amount_arr);

				const commission_list = table_list.filter(list => { return list.total_commission });
				const commission_amount_arr = commission_list.map(list => { return list.total_commission });
				const total_commission = this.totalCalculate(commission_amount_arr);
				
				const net_list = table_list.filter(list => { return list.total_net });
				const net_amount_arr = net_list.map(list => { return list.total_net });
				const total_net = this.totalCalculate(net_amount_arr);
				
				const bill_list = table_list.filter(list => { return list.total_bill });
				const bill_amount_arr = bill_list.map(list => { return list.total_bill });
				const total_bill = this.totalCalculate(bill_amount_arr);
				
				const party_list = table_list.filter(list => { return list.total_party });
				const party_amount_arr = party_list.map(list => { return list.total_party });
				const total_party = this.totalCalculate(party_amount_arr);

				let total_revenue = '';
				const is_same_currency = net_amount_arr.every(net => { return net.currency.id === net_amount_arr[0].currency.id });
				if (is_same_currency) {
					const net_arr = net_amount_arr.map(amount => { return amount.value});
					const bill_arr = bill_amount_arr.map(amount => { return amount.value});

					if (net_arr.length !== 0 && bill_arr.length !== 0) {
						const num_total_net = net_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
						const num_total_bill = bill_arr.reduce((accumulator, currentValue) => accumulator + currentValue);
						const num_total_revenue = num_total_bill === 0 ? 0 : ((num_total_bill - num_total_net) / num_total_bill) * 100;
						total_revenue = `${net_amount_arr[0].currency.code}_${num_total_revenue.toFixed(2)}`;
					}
				}
				
				const last_line_obj = {
					id: 0,
					key: 'total_0',
					kind: '',
					value: '',
					note: '',
					unit: '',
					date: '',
					rate: total_rate,
					commission: total_commission,
					net: total_net,
					bill: total_bill,
					margin: '',
					revenue: total_revenue,
					party: total_party,
				};
				table_list.push(last_line_obj);
				
				media_details_list = table_list;
			}

			return media_details_list;
		},
		normalisedSeachKey() {
			return this.seachKey && this.seachKey.length !== 0 ? this.seachKey.toString().trim().toLowerCase() : '';
		},
		curWeek() {
			let week = [];
			
			const today = moment().weekday();
			if (today >= this.dayOfWeek) {
				const week_start = moment().startOf('week').day(this.dayOfWeek).format('YYYY-MM-DD');
				const week_end = moment().endOf('week').day(this.dayOfWeek + 6).format('YYYY-MM-DD');
				week = [week_start, week_end];
			}
			if (today < this.dayOfWeek) {
				const week_start = moment().startOf('week').day((this.dayOfWeek - 7) % 7).format('YYYY-MM-DD');
				const week_end = moment().endOf('week').day((this.dayOfWeek + 6) % 7).format('YYYY-MM-DD');
				week = [week_start, week_end];
			}

			return week;
		},
		curMonth() {
			let cur_month = [];

			const month_start = moment().startOf('month').format('YYYY-MM-DD');
			const month_end = moment().endOf('month').format('YYYY-MM-DD');
			cur_month = [month_start, month_end];

			return cur_month;
		},
		nextMonth() {
			let next_month = [];

			const next_month_date = moment().add(1, 'month');
			const month_start = next_month_date.clone().startOf('month').format('YYYY-MM-DD');
			const month_end = next_month_date.clone().endOf('month').format('YYYY-MM-DD');
			next_month = [month_start, month_end];

			return next_month;
		},
		lastMonth() {
			let last_month = [];

			const last_month_date = moment().subtract(1, 'month');
			const month_start = last_month_date.clone().startOf('month').format('YYYY-MM-DD');
			const month_end = last_month_date.clone().endOf('month').format('YYYY-MM-DD');
			last_month = [month_start, month_end];

			return last_month;
		},
		totalColspan() {
			let num = 0;

			if (this.taskHeaders.length !== 0) {
				const exsit_column = this.taskHeaders.filter(header => { return Left_Header.includes(header.value) && header.showable === true });
				num = exsit_column.length;
			}

			return num;
		},
		prodColspan() {
			let num = 0;

			if (this.taskHeaders.length !== 0) {
				const exsit_column = this.taskHeaders.filter(header => { return Left_Header.includes(header.value) && header.showable === true });
				exsit_column.forEach(column => {
					if (column.value === 'outlet' || column.value === 'owner' || column.value === 'description' || column.value === 'target' || column.value === 'notes') {
						num += 1;
					}
				});
			}

			return num;
		},
		infoColspan() {
			let num = 0;

			if (this.taskHeaders.length !== 0) {
				const exsit_column = this.taskHeaders.filter(header => { return Left_Header.includes(header.value) && header.showable === true });
				exsit_column.forEach(column => {
					if (column.value === 'kind' || column.value === 'outlet' || column.value === 'owner' || column.value === 'description' || column.value === 'target' || column.value === 'notes') {
						num += 1;
					}
				});
			}

			return num;
		},
		rightBorderKey() {
			let key = '';

			if (this.taskHeaders.length !== 0) {
				const index = this.taskHeaders.findIndex(head => { return !Left_Header.includes(head.value) });
				key = this.taskHeaders[index - 1].value;
			}
			
			return key;
		},
		rightBorderMidKey() {
			let key = '';

			if (this.taskHeaders.length !== 0) {
				const index = this.taskHeaders.findIndex(head => { return !Left_Header.includes(head.value) && !Mid_Header.includes(head.value) });
				key = this.taskHeaders[index - 1].value;
			}
			
			return key;
		},
		ableEdit() {
			let is_able = true;

			if (this.privileges.length !== 0) {
				if (!this.privileges.includes(MEDED)) {
					is_able = false;
				}
			}

			return is_able;
		},
		ableDelete() {
			let is_able = true;

			if (this.privileges.length !== 0) {
				if (!this.privileges.includes(MEDDEL)) {
					is_able = false;
				}
			}

			return is_able;
		}
	},
	watch: {
		error_msg() {
			if (this.error_msg.length !== 0) {
				this.$emit('error', this.error_msg);
				this.error_msg = '';
			}
		}
	},
	methods: {
		getPreSearchArr(value) {
			const value_arr = Array.isArray(value) ? value : [value];
			return value_arr.map(item => {
				if (item === null || item === undefined) {
					return '';
				}
				if (typeof(item) === 'object') {
					return item.display_name || item.owner_name || item.name || item.desc || item.adbShort || '';
				}
				return item.toString();
			}).filter(text => { return text.length !== 0 });
		},
		filterPlanItem(item_obj) {
			let filter_obj = {};

			const header_value_arr = this.taskHeaders.map(header => { return header.value });
			header_value_arr.forEach(header => { 
				filter_obj[`${header}`] = item_obj[`${header}`];
			});

			return filter_obj;
		},
		filterItem(item_obj) {
			let filter_obj = {};

			const header_value_arr = this.taskHeaders.map(header => { return header.value });

			for (const [key, value] of Object.entries(item_obj)) {
				if (key === 'units' && header_value_arr.includes(key)) {
					filter_obj[`${key}`] = value;
				}
				if (key === 'date' && header_value_arr.includes(key)) {
					filter_obj[`${key}`] = value;
				}
				if (key === 'rate' && header_value_arr.includes(key)) {
					filter_obj[`${key}`] = value;
				}
				if (key === 'commission' && header_value_arr.includes(key)) {
					filter_obj[`${key}`] = value;
				}
				if (key === 'net' && header_value_arr.includes(key)) {
					filter_obj[`${key}`] = value;
				}
				if (key === 'bill' && header_value_arr.includes(key)) {
					filter_obj[`${key}`] = value;
				}
				if (key === 'margin' && header_value_arr.includes(key)) {
					filter_obj[`${key}`] = value;
				}
				if (key === 'revenue' && header_value_arr.includes(key)) {
					filter_obj[`${key}`] = value;
				}
				if (key === 'party' && header_value_arr.includes(key)) {
					filter_obj[`${key}`] = value;
				}
			}
			
			return filter_obj;
		},
		filterTotalItem(item_obj) {
			let filter_obj = {};

			const header_value_arr = this.taskHeaders.map(header => { return header.value });

			for (const [key, value] of Object.entries(item_obj)) {
				if (key === 'rate' && header_value_arr.includes(key)) {
					filter_obj[`${key}`] = value;
				}
				if (key === 'commission' && header_value_arr.includes(key)) {
					filter_obj[`${key}`] = value;
				}
				if (key === 'net' && header_value_arr.includes(key)) {
					filter_obj[`${key}`] = value;
				}
				if (key === 'bill' && header_value_arr.includes(key)) {
					filter_obj[`${key}`] = value;
				}
				if (key === 'margin' && header_value_arr.includes(key)) {
					filter_obj[`${key}`] = value;
				}
				if (key === 'revenue' && header_value_arr.includes(key)) {
					filter_obj[`${key}`] = value;
				}
				if (key === 'party' && header_value_arr.includes(key)) {
					filter_obj[`${key}`] = value;
				}
			}
			
			return filter_obj;
		},
		async getSupplierList() {
			this.supplier_loading = true;

			let url = `/api/addressbook/supplier`;

			const params = [];
			params.push("include_media=" + true);
			params.push("include_normal=" + false);
			

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						this.supplier_items = data;
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.supplier_loading = false;
				});
		},
		onOutSideClick() {
			if (this.close_selection !== 0) {
				this.edit_id = '';
				this.close_selection = 0;
			}
		},
		onEditNameDialog() {
			this.phase_dialog_visible = true;
		},
		onKindChange(kind, item_key) {
			if (kind && kind.id !== 0) {
				this.mediaDetailsList.forEach(media_detail => {
					if (media_detail.key === item_key) {
						const kind_orignal = JSON.parse(JSON.stringify(media_detail.kind));

						if (media_detail.record_type === PLAN_TYPE) {
							this.lockPlan(media_detail.id)
								.then(val => {
									const lock_id = val;

									this._updatePlanKind(media_detail.id, kind.id)
										.then(() => {		
											this.unLockPlan(media_detail.id, lock_id);
										})
										.catch((reason) => {
											this.error_msg = reason;
											this.unLockPlan(media_detail.id, lock_id);
											
											media_detail.kind = [];
											media_detail.kind = kind_orignal;
										});
								})
								.catch((reason) => {
									const text = reason === 'ALREADY OWNED' ? Plan_Lock_Text : reason;

									this.notice_text.push(text);
									this.visible_notice = true;

									media_detail.kind = [];
									media_detail.kind = kind_orignal;
								});
						}

						if (media_detail.record_type === PROD_TYPE) {
							this.lockPoduction(media_detail.id)
								.then(val => {
									const lock_id = val;

									this._updateProdKind(media_detail, kind.id)
										.then(() => {		
											this.unLockPoduction(media_detail.id, lock_id);
											this.$emit('close', false);
										})
										.catch((reason) => {
											this.error_msg = reason;
											this.unLockPoduction(media_detail.id, lock_id);
											
											media_detail.kind = [];
											media_detail.kind = kind_orignal;
										});
								})
								.catch((reason) => {
									const text = reason === 'ALREADY OWNED' ? Pord_Lock_Text : reason;

									this.notice_text.push(text);
									this.visible_notice = true;

									media_detail.kind = [];
									media_detail.kind = kind_orignal;
								});
						}						
					}
				});
			}

			this.edit_id = '';
		},
		onSupplierChange(supplier, item_key) {			
			const media = this.mediaDetailsList.filter(media_detail => { return media_detail.key === item_key });

			if (media[0].record_type === PLAN_TYPE) {
				this.lockPlan(media[0].id)
					.then(val => {
						const lock_id = val;
						
						const emit_obj = {
							media: media[0].id,
							supplier: supplier.id,
							edit: true
						};

						this.unLockPlan(media[0].id, lock_id);
						this.$emit('show-booking', emit_obj);
					})
					.catch((reason) => {
						const text = reason === 'ALREADY OWNED' ? Plan_Lock_Text : reason;

						this.notice_text.push(text);
						this.visible_notice = true;
					});
			}
			
			this.edit_id = '';
		},
		onDescChange(desc, item_key) {
			this.mediaDetailsList.forEach(media_detail => {
				if (media_detail.key === item_key) {
					const description_orignal = JSON.parse(JSON.stringify(media_detail.description));
										
					media_detail.description = [];
					media_detail.description = [desc];

					if (media_detail.record_type === PLAN_TYPE) {
						this.lockPlan(media_detail.id)
							.then(val => {
								const lock_id = val;

								this._updatePlanDesc(media_detail.id, desc)
									.then(() => {
										this.unLockPlan(media_detail.id, lock_id);
									})
									.catch((reason) => {
										this.error_msg = reason;
										this.unLockPlan(media_detail.id, lock_id);
											
										media_detail.description = [];
										media_detail.description = description_orignal;
									});
							})
							.catch((reason) => {
								const text = reason === 'ALREADY OWNED' ? Plan_Lock_Text : reason;

								this.notice_text.push(text);
								this.visible_notice = true;

								media_detail.description = [];
								media_detail.description = description_orignal;
							});
					}

					if (media_detail.record_type === PROD_TYPE) {
						this.lockPoduction(media_detail.id)
							.then(val => {
								const lock_id = val;

								this._updateProdDesc(media_detail, desc)
									.then(() => {		
										this.unLockPoduction(media_detail.id, lock_id);
										this.$emit('close', false);
									})
									.catch((reason) => {
										this.error_msg = reason;
										this.unLockPoduction(media_detail.id, lock_id);
											
										media_detail.description = [];
										media_detail.description = description_orignal;
									});
							})
							.catch((reason) => {
								const text = reason === 'ALREADY OWNED' ? Pord_Lock_Text : reason;

								this.notice_text.push(text);
								this.visible_notice = true;

								media_detail.description = [];
								media_detail.description = description_orignal;
							});
					}						
				}
			});

			this.edit_id = '';
		},
		onTargetChange(target, item_key) {
			this.mediaDetailsList.forEach(media_detail => {
				if (media_detail.key === item_key) {
					const target_orignal = JSON.parse(JSON.stringify(media_detail.target));

					media_detail.target = [];
					media_detail.target = [target];

					if (media_detail.record_type === PLAN_TYPE) {
						this.lockPlan(media_detail.id)
							.then(val => {
								const lock_id = val;

								this._updatePlanTarget(media_detail.id, target)
									.then(() => {
										this.unLockPlan(media_detail.id, lock_id);
									})
									.catch((reason) => {
										this.error_msg = reason;
										this.unLockPlan(media_detail.id, lock_id);
											
										media_detail.target = [];
										media_detail.target = target_orignal;
									});
							})
							.catch((reason) => {
								const text = reason === 'ALREADY OWNED' ? Plan_Lock_Text : reason;

								this.notice_text.push(text);
								this.visible_notice = true;

								media_detail.target = [];
								media_detail.target = target_orignal;
							});
					}
				}
			});
			
			this.edit_id = '';
		},
		onNoteChange(note, item_key) {
			this.mediaDetailsList.forEach(media_detail => {
				if (media_detail.key === item_key) {
					const notes_orignal = JSON.parse(JSON.stringify(media_detail.notes));

					media_detail.notes = [];
					media_detail.notes = [note];

					if (media_detail.record_type === PLAN_TYPE) {
						this.lockPlan(media_detail.id)
							.then(val => {
								const lock_id = val;

								this._updatePlanNotes(media_detail.id, note)
									.then(() => {
										this.unLockPlan(media_detail.id, lock_id);
									})
									.catch((reason) => {
										this.error_msg = reason;
										this.unLockPlan(media_detail.id, lock_id);
											
										media_detail.notes = [];
										media_detail.notes = notes_orignal;
									});
							})
							.catch((reason) => {
								const text = reason === 'ALREADY OWNED' ? Plan_Lock_Text : reason;

								this.notice_text.push(text);
								this.visible_notice = true;

								media_detail.notes = [];
								media_detail.notes = notes_orignal;
							});
					}
				}
			});
			
			this.edit_id = '';
		},
		onUnitEdit(item) {
			if (item && item.record_type === PROD_TYPE) {
				this.lockPoduction(item.id)
					.then(val => {
						const lock_id = val;
						this.unLockPoduction(item.id, lock_id);

						const prod = {
							id: item.id,
							edit: true
						}
						this.$emit('prod', prod);
					})
					.catch(() => {
						const prod = {
							id: item.id,
							edit: false
						}
						this.$emit('prod', prod);
					});
			}
			if (item && item.record_type === INFO_TYPE) {
				this.$emit('info', item.id);
			} 
			if (item && item.record_type === TPC_TYPE) {
				this.$emit('tcp', item.id)
			}
		},
		onShowBooking(media_id) {
			this.lockPlan(media_id)
				.then(val => {
					const lock_id = val;
					this.unLockPlan(media_id, lock_id);

					const media = {
						media: media_id,
						supplier: 0,
						edit: true
					};

					this.$emit('show-booking', media);
				})
				.catch((reason) => {
					const text = reason === 'ALREADY OWNED' ? Plan_Lock_Text : reason;

					this.notice_text.push(text);
					this.visible_notice = true;

					const media = {
						media: media_id,
						supplier: 0,
						edit: false
					};

					this.$emit('show-booking', media);
				});
		},
		onDeleteMediaPlan(item_obj) {
			if (item_obj && item_obj.record_type === PLAN_TYPE) {
				this.lockPlan(item_obj.id)
					.then(val => {
						const lock_id = val;
						this.unLockPlan(item_obj.id, lock_id);

						this.content_msg = `This will delete ${item_obj.booking_plan} bookings totalling ${item_obj.total_bill_client}. This cannot be undone. Are you sure?`;
						this.delete_media_id = item_obj.id;
						this.delete_confirm_visible = true;
					})
					.catch((reason) => {
						const text = reason === 'ALREADY OWNED' ? Plan_Lock_Text : reason;

						this.notice_text.push(text);
						this.visible_notice = true;
					});
			}

			if (item_obj && item_obj.record_type === PROD_TYPE) {
				this.lockPoduction(item_obj.id)
					.then(val => {
						const lock_id = val;
						const url_prod = `/api/media/media_planning/production/${item_obj.id}`;

						this._delProd(url_prod)
							.then(() => {		
								this.unLockPoduction(item_obj.id, lock_id);
								this.$emit('close', true);
							})
							.catch((reason) => {
								this.error_msg = reason;
								this.unLockPoduction(item_obj.id, lock_id);
							});
					})
					.catch((reason) => {
						const text = reason === 'ALREADY OWNED' ? Pord_Lock_Text : reason;

						this.notice_text.push(text);
						this.visible_notice = true;
					});
			}

			let url = '';

			if (item_obj && item_obj.record_type === INFO_TYPE) {
				url = `/api/media/media_planning/info/${item_obj.id}`;
			} 
			if (item_obj && item_obj.record_type === TPC_TYPE) {
				url = `/api/media/media_planning/tpc/${item_obj.id}`;
			}

			if (url.length !== 0) {
				axios
					.delete(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const { status, reason } = val.data;

						if (status == "OK") {
							this.$emit('close', true)
						} else {
							this.error_msg = reason;
						}
					})
					.catch(e => {
						this.error_msg = e.message;
					})
					.finally(() => {
					});
			}
		},
		onDelMediaPlan() {
			const url = `/api/media/media_planning/${this.delete_media_id}`;

			axios
				.delete(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.content_msg = '';
						this.delete_media_id = 0;
						this.delete_confirm_visible = false;
							
						this.$emit('close', true)
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		totalCalculate(total_arr) {
			let total_rate_str = '';

			if (total_arr.length !== 0) {
				const currency_id = total_arr[0].currency.id;
				const is_same_currency = total_arr.every(amount => { return amount.currency.id === currency_id });

				if (is_same_currency) {
					const value_arr = total_arr.map(amount => { return amount.value});
					const supp_amount = value_arr.reduce((accumulator, currentValue) => accumulator + currentValue);

					const amount = new Decimal(supp_amount);
					const fixed_amount = amount.toFixed(2);
					const formatted_amount = new Intl.NumberFormat('en-US', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2
					}).format(fixed_amount);

					total_rate_str = `${total_arr[0].currency.code}_${formatted_amount}`;
				}
			}
			
			return 	total_rate_str;
		},
		isFallRange(start_date, date_range) {
			if (date_range.length === 0) {
				return true;
			}

			return moment(start_date).isBetween(date_range[0], date_range[1], undefined, '[]');
		},
		lockPlan(plan_id) {
			let url = `/api/media/media_planning/${plan_id}/lock_plan`;

			return new Promise((resolve, reject) => {
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, lock_id, reason } = json;

						if (status == "OK") {
							resolve(lock_id);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});
		},
		unLockPlan(plan_id, lock_id) {
			let url = `/api/media/media_planning/${plan_id}/unlock_plan`;

			const params = [];
			params.push("lock_id=" + lock_id);
			
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						console.log(data)
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		lockPoduction(prod_id) {
			let url = `/api/media/media_planning/production/${prod_id}/lock_poduction`;

			return new Promise((resolve, reject) => {
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, lock_id, reason } = json;

						if (status == "OK") {
							resolve(lock_id);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});
		},
		unLockPoduction(prod_id, lock_id) {
			let url = `/api/media/media_planning/production/${prod_id}/unlock_poduction`;

			const params = [];
			params.push("lock_id=" + lock_id);
			
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const {status, data, reason} = val.data;

					if (status === "OK") {
						console.log(data)
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
				});
		},
		_updateInfo(info) {
			const info_origin = this.media.details.filter(d => { return d.id === info.id && d.record_type === info.record_type });

			const params_obj = {
				phase_id: info.phase.id,
				info_text: info.description,
				order: info.order,
				do_print: info_origin[0].do_print,
			};
			params_obj['info_rtf'] = info.description.length !== 0 ? htmlToRtf.convertHtmlToRtf(info.description): '';

			if (this.snapId !== 0) {
				params_obj['snap_id'] = this.snapId
			}

			const url = `/api/media/media_planning/info/${info.id}`;

			axios
				.put(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.$emit('close', false)
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		_updateProd(prod) {
			const prod_origin = this.media.details.filter(d => { return d.id === prod.id && d.record_type === prod.record_type });

			const params_obj = {
				phase_id: prod.phase.id,
				kind_id: this.groupBy === Group_Kind ? prod_origin[0].kind.id : prod.kind[1].id,
				prod_start: moment(prod_origin[0].prod_start, 'YYYYMMDD').format('YYYY-MM-DD'),
				prod_end: moment(prod_origin[0].prod_end, 'YYYYMMDD').format('YYYY-MM-DD'),
				description: prod.description[0],
				amount_div: prod_origin[0].amount_div,
				status: prod_origin[0].status,
				do_print: prod_origin[0].do_print,
				do_not_bill: prod_origin[0].do_not_bill,
				order: prod_origin[0].order
			};

			const url = `/api/media/media_planning/production/${prod.id}`;

			axios
				.put(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.$emit('close', false)
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		_updateProdKind(prod, kind_id) {
			const prod_origin = this.media.details.filter(d => { return d.id === prod.id && d.record_type === prod.record_type });

			const params_obj = {
				phase_id: prod.phase.id,
				kind_id: this.groupBy === Group_Kind ? prod_origin[0].kind.id : kind_id,
				prod_start: moment(prod_origin[0].prod_start, 'YYYYMMDD').format('YYYY-MM-DD'),
				prod_end: moment(prod_origin[0].prod_end, 'YYYYMMDD').format('YYYY-MM-DD'),
				description: prod.description[0],
				amount_div: prod_origin[0].amount_div,
				status: prod_origin[0].status,
				do_print: prod_origin[0].do_print,
				do_not_bill: prod_origin[0].do_not_bill,
				order: prod_origin[0].order
			};

			const url = `/api/media/media_planning/production/${prod.id}`;

			return new Promise((resolve, reject) => {
				axios
					.put(url, params_obj, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});
		},
		_updateProdDesc(prod, desc) {
			const prod_origin = this.media.details.filter(d => { return d.id === prod.id && d.record_type === prod.record_type });

			const params_obj = {
				phase_id: prod.phase.id,
				kind_id: this.groupBy === Group_Kind ? prod_origin[0].kind.id : prod.kind[1].id,
				prod_start: moment(prod_origin[0].prod_start, 'YYYYMMDD').format('YYYY-MM-DD'),
				prod_end: moment(prod_origin[0].prod_end, 'YYYYMMDD').format('YYYY-MM-DD'),
				description: desc,
				amount_div: prod_origin[0].amount_div,
				status: prod_origin[0].status,
				do_print: prod_origin[0].do_print,
				do_not_bill: prod_origin[0].do_not_bill,
				order: prod_origin[0].order
			};

			const url = `/api/media/media_planning/production/${prod.id}`;

			return new Promise((resolve, reject) => {
				axios
					.put(url, params_obj, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});
		},
		_delProd(url) {
			return new Promise((resolve, reject) => {
				axios
					.delete(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});
		},
		_updatePlan(plan) {
			const plan_origin = this.media.details.filter(d => { return d.id === plan.id && d.record_type === plan.record_type });

			const params_bookings = [];
			plan_origin[0].bookings.forEach(b => {
				const obj = {};
				obj['id'] = b.id;
				obj['booking_type'] = b.booking_type;
				obj['plan_id'] = plan_origin[0].id;
				obj['rev_id'] = b.rev_id;
				obj['booking_start'] = moment(b.booking_start, 'YYYYMMDD').format('YYYY-MM-DD');
				obj['booking_end'] = moment(b.booking_end, 'YYYYMMDD').format('YYYY-MM-DD');
				obj['units'] = b.units;
				obj['rate_fc'] = b.rate_fc;
				obj['rate_div'] = b.rate_div;
				obj['amount_fc'] = b.amount_fc;
				obj['amount_div'] = b.amount_div;
				obj['status'] = b.status;
				obj['is_foc'] = b.is_foc;
				obj['comm_perc'] = b.comm_perc;
				obj['commamount_fc'] = b.commamount_fc;
				obj['commamount_div'] = b.commamount_fc;
				obj['margin_fc'] = b.margin_fc;
				obj['margin_div'] = b.margin_div;
				obj['net_fc'] = b.net_fc;
				obj['net_div'] = b.net_div;
				obj['booking_mode'] = b.booking_mode;
				obj['markup_perc'] = b.markup_perc;
				obj['markupamount_fc'] = b.markupamount_fc;
				obj['markupamount_div'] = b.markupamount_div;
				obj['donotbill'] = b.donotbill;
				obj['value_fc'] = b.value_fc;
				obj['value_div'] = b.value_div;
				obj['exrate_div'] = b.exrate_div;
				obj['exrate_cost'] = b.exrate_div;
				obj['exrate_value'] = b.exrate_value;
				obj['is_deleted'] = b.is_deleted;
				obj['is_vouchered'] = b.is_vouchered;

				/** radio holidings, leave empty for now */
				obj['pos_in_break'] = '';
				obj['mat_key_identifier'] = '';
				obj['priority_modifier'] = '';
				obj['med_ref_id'] = '';
				obj['booking_day_flags'] = '';
				obj['booking_start_time'] = '';
				obj['booking_end_time'] = '';
				obj['prog_name'] = ''; 
				obj['contract_ref'] = '';
				obj['network_code'] = '';

				params_bookings.push(obj);
			});

			const params_obj = {};
			params_obj['phase_id'] = plan_origin[0].phase.id;
			params_obj['supplier_id'] = plan_origin[0].supplier.id;
			params_obj['kind_id'] = this.groupBy === Group_Kind ? plan_origin[0].kind.id : plan.kind[1].id;
			params_obj['cost_curr_id'] = plan_origin[0].cost_currency.id;
			params_obj['value_curr_id'] = plan_origin[0].value_currency.id;
			params_obj['description'] = plan.description[0];
			params_obj['target'] = plan.target[0];
			params_obj['notes'] = plan.notes[0];
			params_obj['do_print'] = plan_origin[0].do_print;
			params_obj['exrate_margin_perc'] = plan_origin[0].exrate_margin_perc;
			params_obj['bookings'] = params_bookings;

			const url = `/api/media/media_planning/${plan.id}`;

			axios
				.put(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.$emit('close', false)
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		_updatePlanKind(media_id, kind_id) {
			let url = `/api/media/media_planning/${media_id}/set_media_kind`;

			const params = [];
			params.push("kind_id=" + kind_id);
			
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			return new Promise((resolve, reject) => {
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});
		},
		_updatePlanDesc(media_id, desc) {
			let url = `/api/media/media_planning/${media_id}/set_media_description`;

			const params = [];
			params.push("description=" + desc);
			
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			return new Promise((resolve, reject) => {
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});
		},
		_updatePlanTarget(media_id, target) {
			let url = `/api/media/media_planning/${media_id}/set_media_target`;

			const params = [];
			params.push("target=" + target);
			
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			return new Promise((resolve, reject) => {
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});
		},
		_updatePlanNotes(media_id, notes) {
			let url = `/api/media/media_planning/${media_id}/set_media_notes`;

			const params = [];
			params.push("notes=" + notes);
			
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			return new Promise((resolve, reject) => {
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});
		},
		close() {
			this.visible_notice = false;
			this.notice_text = [];
		},
	}
}
</script>

<style lang="scss" scoped>
.header-top {
  display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	padding: 0 20px;
	background: #FAFAFA;
	color: #192A3E;
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 24px;
	border-bottom: 1px solid #C9C9C9;
	border-radius: 4px 4px 0 0;
	span {
		font-weight: bold;
	}
}
.header-top-height { 
	height: 48px;
}
.font-normal-style {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	line-height: 36px;
	letter-spacing: 0.5px;
	vertical-align: middle;
}
.font-bold-style {
	font-family: Roboto;
	font-weight: 500;
	font-size: 14px;
	line-height: 36px;
	letter-spacing: 0.25px;
	vertical-align: middle;
}
.font-header-style {
	color: #192A3E;
}
.selector-item-style {
	color: #605AF6;
}
.hover-border {
  padding: 4px 8px;
  &:hover {
    border: 1px solid rgba(25, 42, 62, 0.3);
    border-radius: 4px;
  }
}
.hover-borde-empty {
	margin: 0 4px;
  padding: 4px 8px;
	min-width: 160px;
  &:hover {
    border: 1px solid rgba(25, 42, 62, 0.3);
    border-radius: 4px;
  }
}
.over-text {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.foc-style {
	font-family: Roboto;
	font-weight: 500;
	font-size: 12px;
	color: rgba(25, 42, 62, 0.5);
}
.disable-btn.v-btn--disabled {
  /* Re-enable pointer events so the cursor style can be applied */
  pointer-events: auto !important;
  /* Set the desired cursor style */
  cursor: not-allowed !important; 
}


::v-deep {
	.media-plan-table > .v-data-table__wrapper > table {
		table-layout: fixed;
	}
  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    padding-right: 0;
    padding-left: 0;
  }
	.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    background:#EAEAEA;
  }
  .total.v-data-table > .v-data-table__wrapper > table > tbody > tr:last-child { 
    background:#E5E5E5;
  }
  .select-in-cell > .v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
    min-height: 24px;
		min-width: 186px;
		max-width: 186px;

		font-family: Roboto;
		font-weight: 400;
		font-size: 14px;
		line-height: 36px;
		letter-spacing: 0.5px;
		vertical-align: middle;
  }
  .field-in-cell.v-text-field .v-input__control .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
  }
  .field-in-cell.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
    margin-top: 0;
    margin-right: 4px;
  }
  .field-in-top.theme--light.v-input input {
    color: #605AF6;
  }
}

.info-description-row,
.info-description {
	min-width: 0;
	max-width: 100%;
}
.info-description {
	text-align: start;
	white-space: normal;
	overflow-wrap: anywhere;
}

</style>
